<ngx-loading [show]="loading" style="z-index: 9999;"></ngx-loading>
<mat-accordion>
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="row-candidates">
          Nume: {{candidate.user.name}}
        </div>
      </mat-panel-title>
      <mat-panel-description>Status: {{candidate.candidation.status}}</mat-panel-description>
    </mat-expansion-panel-header>
    <mat-divider></mat-divider>

    <p>Nume: {{candidate.user.name}}</p>
    <p>Email: {{candidate.user.email}}</p>
    <p>Status: {{candidate.candidation.status}}</p>
    <p>Data aplicarii: {{candidate.candidation.created_at | date: 'dd-MM-yyyy HH:mm'}}</p>
    <p>Ultimul status: {{candidate.candidation.updated_at | date: 'dd-MM-yyyy HH:mm'}}</p>

    <p *ngIf="cvLinkList.length === 0">Link CV: <b>Nu este disponibil</b></p>
    <p *ngIf="cvLinkList.length > 0">Link CV: <button mat-button (click)="downloadCV()">Click</button></p>


    <!-- <p>Chestionare: <button mat-button (click)="openQuestionnaire()">Click</button> </p> -->

    <div class="actions" *ngIf="candidate.candidation.status === 'Aplicat'">
      <button mat-button color="warn" (click)="onDeclineButton()">Respinge</button>
      <button mat-button color="primary" (click)="onAcceptButton()">Accepta</button>
    </div>

    <mat-divider></mat-divider>
  </mat-expansion-panel>
</mat-accordion>

